import { NavLink, Link } from 'react-router-dom'

function Header() {
    return (
        <>
            <div className="header container">
                <ul className='d-flex align-items-center container mt-4 d-none d-md-block d-md-flex'>
                    <Link to={"/"} className='header-logo me-auto'>Shamsiddinov.uz</Link>
                    <li>
                        <NavLink className='header-link' to='/portfolio'>Portfolio</NavLink>
                        <NavLink className='header-link' to='/blog'>Blog</NavLink>
                        <NavLink className='header-link' to='/volunteering'>Volunteering</NavLink>
                        <a href='https://t.me/Abbos_Shamsiddin' target="_blank" rel="noopener noreferrer" className='header-link'>Channel</a>
                    </li>
                </ul>

                {/* OFFCANVAS */}

                <div>
                    <div className='d-flex align-items-center offcanvas-head'>
                        <Link to={"/"} className='me-auto header-logo d-block d-md-none'>Shamsiddinov.uz</Link>
                        <button className="btn d-block d-md-none text-dark fs-1" type="button" data-bs-toggle="offcanvas" data-bs-target="#offcanvasTop" aria-controls="offcanvasTop">&equiv;</button>
                    </div>

                    <div className="offcanvas offcanvas-top w-100 off-body" tabIndex="-1" id="offcanvasTop" aria-labelledby="offcanvasTopLabel">
                        <div className="offcanvas-header">
                            <Link to={"/"} className='header-logo d-block'>Shamsiddinov.uz</Link>
                            <button type="button" className="btn-close" data-bs-dismiss="offcanvas" aria-label="Close"></button>
                        </div>
                        <div className="offcanvas-body">
                            <div className='d-flex flex-column align-items-center text-center'>
                                <NavLink className='mb-3 header-link offcanvas-link' to='/portfolio'>Portfolio</NavLink>
                                <NavLink className='mb-3 header-link offcanvas-link' to='/blog'>Blog</NavLink>
                                <NavLink className='mb-3 header-link offcanvas-link' to='/volunteering'>Volunteering</NavLink>
                                <a href='https://t.me/Abbos_Shamsiddin' target="_blank" rel="noopener noreferrer" className='header-link offcanvas-link'>Channel</a>
                            </div>
                        </div>
                    </div>
                </div>

                {/* OFFCANVAS */}
            </div>
        </>
    );
}

export default Header;
